<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '数据流'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    top="5vh"
    :close-on-click-modal="false">
    <el-form :model="item" ref="itemform" label-width="100px" :rules="rules">
      <el-form-item label="数据流名称" prop="Name">
        <el-input v-model.trim="item.Name" placeholder="请输入数据流名称"></el-input>
      </el-form-item>
      <el-form-item label="数据流路径" prop="Keypath">
        <el-input v-model.trim="item.Keypath" placeholder="请输入数据流路径"></el-input>
      </el-form-item>
      <el-form-item label="数据类型" prop="Type">
        <el-select
          v-model="item.Type"
          placeholder="请选择数据类型"
          style="width: 100%;"
          @change="onChangeType"
          >
          <el-option v-for="ele in typeList" :key="ele.key" :label="ele.value" :value="ele.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="候选项" prop="Options" v-if="item.Type === 'enum'">
        <el-row>
          <div class="text-center">点击右侧添加数据类型选项
            <el-button type="success" round class="pull-right" size="mini" @click="onAddItem">
              <i class="fas fa-plus"></i>
            </el-button>
          </div>
        </el-row>
        <el-row v-for="(ele, index) in item.Options" :key="index">
          <div class="mar-r-xl">
            <el-col :span="12">
              <el-input v-model="item.Options[index].Key" placeholder="值"></el-input>
            </el-col>
            <el-col :span="12">
              <el-input class="mar-l-xs" v-model="item.Options[index].Value" placeholder="标签"></el-input>
            </el-col>
          </div>
          <div class="pad-t-xs">
            <el-button type="danger" round class="pull-right" size="mini" @click="deleteItem(index)">
              <i class="fas fa-minus"></i>
            </el-button>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="候选项" prop="Options" v-if="item.Type === 'bool'">
        <el-row>
          <el-col :span="12">
            <el-input disabled value="true"></el-input>
          </el-col>
          <el-col :span="12">
            <el-input class="mar-l-xs" v-model="item.Options[0].Value" placeholder="标签"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-input disabled value="false"></el-input>
          </el-col>
          <el-col :span="12">
            <el-input class="mar-l-xs" v-model="item.Options[1].Value" placeholder="标签"></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="显示优先级" prop="Priority">
        <el-input-number v-model="item.Priority"></el-input-number>
        <span class="pad-l-md">数字越小越靠前显示</span>
      </el-form-item>
      <el-form-item label="显示在列表" prop="Exhibited">
        <el-switch v-model="item.Exhibited"></el-switch>
      </el-form-item>
      <el-form-item label="显示模板" prop="Template">
        <el-input type="textarea" v-model="item.Template" placeholder="格式化最终显示的模板"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit"
        :disabled="submitting || !item.Name || !item.Keypath"
        >
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      typeList: [
        { key: 'text', value: '文本' },
        { key: 'float', value: '数字' },
        { key: 'enum', value: '枚举' },
        { key: 'bool', value: '布尔' },
      ],
      rules: {
        Name: [
          { required: true, message: '数据集名称不能为空', trigger: 'blur' },
        ],
        Keypath: [
          { required: true, message: '数据集编号不能为空', trigger: 'blur' },
        ],
      },
      submitting: false,
    };
  },
  methods: {
    onOpen() {
      this.item = _.clone(this.value);
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
    },
    onChangeType(val) {
      if (val === 'bool') {
        this.item.Options = [
          { Key: true, Value: '' },
          { Key: false, Value: '' },
        ];
      } else {
        this.item.Options = [];
      }
    },
    // 新增候选项
    onAddItem() {
      this.item.Options.push({ Key: '', Value: '' });
    },
    // 删除候选项
    deleteItem(i) {
      this.item.Options.splice(i, 1);
    },
    // 保存数据流
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) return;
        this.submitting = true;
        this.$emit('input', this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios.request({
          url: this.item.ID ? `category/stream/${itemData.ID}` : 'category/stream',
          method: itemData.ID ? 'put' : 'post',
          data: itemData,
        }).then(() => {
          this.$message.success(itemData.ID ? '成功修改数据流' : '成功新增数据流');
          this.submitting = false;
          this.$emit(itemData.ID ? 'form:updated' : 'form:created', true);
          this.$emit('form:saved', true);
          this.$emit('update:visible', false);
        }).catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.submitting = false;
          this.$emit(itemData.ID ? 'form:updated' : 'form:created', false);
          this.$emit('form:saved', false);
        });
      });
    },
  },
};
</script>
